import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "select2-drpdwn" }
const _hoisted_3 = { class: "row" }

import { defineAsyncComponent } from 'vue';

export default /*@__PURE__*/_defineComponent({
  __name: 'indexSelect',
  setup(__props) {

const SelectView = defineAsyncComponent(() => import("@/components/theme/forms/formwidgets/select2/SelectView.vue"))
const OutlineColor = defineAsyncComponent(() => import("@/components/theme/forms/formwidgets/select2/OutlineColor.vue"))
const FullColored = defineAsyncComponent(() => import("@/components/theme/forms/formwidgets/select2/FullColored.vue"))

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_unref(SelectView)),
        _createVNode(_unref(OutlineColor)),
        _createVNode(_unref(FullColored))
      ])
    ])
  ]))
}
}

})